import React from 'react';
import { Typography } from '@mui/material';
import { GuideSection } from '../common/GuideSection';
import { GuideSubsection } from '../common/GuideSubsection';
import { StepByStep } from '../common/StepByStep';
import { Tip } from '../common/Tip';
import { Warning } from '../common/Warning';
import { useTranslation } from '../../../i18n';

export const HealthPanelSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <GuideSection id="health-panel" title={t('guide.sections.healthPanel')}>
      <Typography variant="body1" sx={{ mb: 2, color: '#555' }}>
        {t('guide.healthPanel.intro')}
      </Typography>

      <StepByStep
        steps={[
          t('guide.healthPanel.openingSteps.s1'),
          t('guide.healthPanel.openingSteps.s2'),
          t('guide.healthPanel.openingSteps.s3'),
        ]}
      />

      <GuideSubsection id="health-avgr" title={t('guide.healthPanel.avgr.title')}>
        <Typography variant="body1" sx={{ color: '#555' }}>
          {t('guide.healthPanel.avgr.description')}
        </Typography>
      </GuideSubsection>

      <GuideSubsection id="health-avgt" title={t('guide.healthPanel.avgt.title')}>
        <Typography variant="body1" sx={{ color: '#555' }}>
          {t('guide.healthPanel.avgt.description')}
        </Typography>
        <Warning>{t('guide.healthPanel.avgt.warningRSquared')}</Warning>
      </GuideSubsection>

      <GuideSubsection id="health-tuwt" title={t('guide.healthPanel.tuwt.title')}>
        <Typography variant="body1" sx={{ color: '#555' }}>
          {t('guide.healthPanel.tuwt.description')}
        </Typography>
      </GuideSubsection>

      <GuideSubsection id="health-action" title={t('guide.sections.healthPanelAction')}>
        <Typography variant="body1" sx={{ color: '#555' }}>
          {t('guide.healthPanel.action.description')}
        </Typography>
        <Tip>{t('guide.healthPanel.tipDataPoints')}</Tip>
      </GuideSubsection>
    </GuideSection>
  );
};
